<template>
  <div>
    <div v-drag class="circle" :class="{ open: isOpen }">
      <div class="ring">
        <a
          :style="{ top: topDistance(index), left: leftDistance(index) }"
          class="menuItem"
          v-for="(item, index) in menuItemList"
          :key="index + 'a'"
          :class="item.iconName"
          @click="clickItem(item)"
        ></a>
      </div>
      <a class="center iconfont icon-th" @click="isOpen = !isOpen"></a>
    </div>
    <el-dialog
      top="8vh"
      :title="dialogTitle || currentTitle"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :modal="false"
      :before-close="handleClose"
      v-dialogDrag
    >
      <slot></slot>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isOpen: false,
      currentTitle: '',
      dialogVisible: false,
      menuItemList: [
        {
          value: 0,
          iconName: 'fa-warning',
          title: '报警信息',
          componentName: 'WarnningsList',
        },
        {
          value: 1,
          iconName: 'fa-photo',
          title: '实时监控',
          componentName: 'RealMonitoring',
        },
        {
          value: 4,
          iconName: 'fa-video-camera',
          title: '视频监控',
          componentName: 'VideoCamera',
        },
        {
          value: 7,
          iconName: 'fa-cog',
          title: '其他信息',
          componentName: 'OtherInfo',
          type: 'otherMsg',
        },
        {
          value: 2,
          iconName: 'fa-suitcase',
          title: '运行信息',
          componentName: 'FaultLibrary',
          type: 'spareParts',
        },
      ],
    }
  },
  props: {
    dialogWidth: {
      type: String,
      default: () => {
        return '30%'
      },
    },
    dialogTitle: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  computed: {},
  methods: {
    // 定位top
    topDistance(index) {
      return `${(
        50 -
        35 * Math.cos(-0.5 * Math.PI - 2 * (1 / this.menuItemList.length) * index * Math.PI)
      ).toFixed(4)}%`
    },
    // 定位left
    leftDistance(index) {
      return `${(
        50 +
        35 * Math.sin(-0.5 * Math.PI - 2 * (1 / this.menuItemList.length) * index * Math.PI)
      ).toFixed(4)}%`
    },
    clickItem(item) {
      this.$emit('sendCurrentType', item)
      this.dialogVisible = true
      this.currentTitle = item.title
    },
    handleClose() {
      this.$emit('handleClose')
      this.dialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>

/deep/.el-dialog {
  background: #071c32 !important;
  color: #fff !important;
  .el-dialog__body {
    color: #ffffff !important;
    min-height: 300px;
  }
  .el-dialog__title {
    color: #ffffff !important;
  }
}
a {
  font-size: 18px;
  text-decoration: none;
  outline: 0;
}
.circle,
.ring {
  height: 180px;
  position: absolute;
  width: 180px;
}

.circle {
  bottom: 30px;
  right: 20px;
}

.ring {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  opacity: 0;
  transform-origin: 50% 50%;
  transform: scale(0.1) rotate(-270deg);
  transition: all 0.4s ease-out;
}

.open .ring {
  opacity: 1;
  transform: scale(1) rotate(0);
}

.center {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border: 2px solid #ffffff;
  bottom: 0;
  color: white;
  height: 60px;
  left: 0;
  line-height: 60px;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  width: 60px;
  transition: all 0.4s ease-out;
}

.open .center {
  border-color: #aaaaaa;
}

.menuItem {
  border-radius: 50%;
  color: #eeeeee;
  display: block;
  height: 40px;
  line-height: 40px;
  margin-left: -20px;
  margin-top: -20px;
  position: absolute;
  text-align: center;
  width: 40px;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

</style>
